import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "mb-2 relative" }
const _hoisted_4 = { class: "absolute bg-white border border-gray-200 rounded-md shadow-sm mt-2 bg-white z-50 h-64 overflow-auto w-full" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Check Address!")
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "shadow-sm transition duration-250 w-full lg:w-auto flex items-center justify-center px-6 py-4 text-base md:text-md rounded-lg text-brand-button-text bg-brand-button hover:bg-brand-button-hover md:text-lg md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://unitiinternet.com?from=bloom" }, "Go to Uniti Internet")
], -1)
const _hoisted_10 = [
  _hoisted_9
]

import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { ref, watch } from 'vue';
import AsyncButton from '../library/AsyncButton.vue';
import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*#__PURE__*/_defineComponent({
  props: {
    autocompletedAddresses: { type: Array, required: true },
    address: { type: String, required: true }
  },
  emits: ["onCheckAddressClicked", "onAddressSearchInputted", "onAutocompletedAddressClicked"],
  setup(__props: any, { emit }: { emit: ({(e: 'onCheckAddressClicked', address: string, done: () => void): void, (e: 'onAddressSearchInputted', address: string): void, (e: 'onAutocompletedAddressClicked', address: Address): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  autocompletedAddresses: Array<Address>,
  address: string
}
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Events.


// Props.


// Data.
const addressInput = ref('');
let debounce: number | null = null;

// Watch data.
watch(() => props.address, (selection) => {
  addressInput.value = selection;
});

// Alert parents that the user has typed
// into the address search input.
const handleAddressSearchInputted = () => {
  if (debounce !== null) {
    clearTimeout(debounce);
  }

  if (addressInput.value.length > 4) {
    debounce = setTimeout(() => {
      emit('onAddressSearchInputted', addressInput.value);
    }, 300);
  }
};

// Alert parents that the user has submitted
// the address.
const handleCheckAddressClicked = (done: () => void) => {
  emit('onCheckAddressClicked', addressInput.value, done);
};

// Alert parents that an address from the autocomplete
// has been clicked.
const handleAutocompletedAddressClicked = (autocompletedAddress: Address) => {
  emit('onAutocompletedAddressClicked', autocompletedAddress);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("p", {
      class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-medium text-gray-500' : 'font-medium text-black', "text-xl leading-6"])
    }, "Enter your address to get started' ", 2), [
      [_vShow, _unref(brandService).getName() !== _unref(Brand).BLM]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          onKeyup: handleAddressSearchInputted,
          onPaste: handleAddressSearchInputted,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (addressInput.value = $event)),
          autocomplete: "off",
          type: "text",
          name: "address-search",
          id: "primary-address-search",
          class: "transition duration-250 shadow-sm rounded-md border border-gray-200 appearance-none min-w-0 w-full bg-white border border-transparent rounded-lg py-4 px-4 text-base md:text-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-secondary focus:ring-gray-50 focus:border-brand-secondary focus:placeholder-gray-400",
          placeholder: "1/20 Example Street, Sydney"
        }, null, 544), [
          [_vModelText, addressInput.value]
        ]),
        _createVNode(_Transition, {
          "leave-active-class": "transition duration-250",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.autocompletedAddresses, (address) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (handleAutocompletedAddressClicked(address)),
                  class: "p-4 cursor-pointer hover:bg-brand-button-hover text-left",
                  key: address.id
                }, _toDisplayString(address.address), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vShow, __props.autocompletedAddresses.length]
            ])
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _unref(brandService).getName() !== _unref(Brand).BLM]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(AsyncButton, { onOnClick: handleCheckAddressClicked }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _unref(brandService).getName() !== _unref(Brand).BLM]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
        [_vShow, _unref(brandService).getName() === _unref(Brand).BLM]
      ])
    ])
  ]))
}
}

})